// Function to handle responsive autoplay for benefit bar swipers
function handleBenefitBarAutoplay() {
  const benefitBarSwipers = document.querySelectorAll('.benefit-bar .swiper');

  benefitBarSwipers.forEach((swiperEl) => {
    if (swiperEl.swiper && swiperEl.swiper.autoplay) {
      const swiper = swiperEl.swiper;

      if (window.innerWidth >= 768) {
        // Enable autoplay on desktop
        if (!swiper.autoplay.running) {
          swiper.autoplay.start();
        }
      } else {
        // Disable autoplay on mobile and reset to first slide
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
        // Reset to first slide when switching to mobile
        if (swiper.activeIndex !== 0) {
          swiper.slideTo(0, 0); // Instant transition to first slide
        }
      }
    }
  });
}

// Wait for swiper instances to be ready
function waitForSwipers() {
  const benefitBarSwipers = document.querySelectorAll('.benefit-bar .swiper');
  const allReady = Array.from(benefitBarSwipers).every(
    (swiperEl) => swiperEl.swiper && swiperEl.swiper.autoplay
  );

  if (allReady) {
    handleBenefitBarAutoplay();
  } else {
    // Check again in a short time
    setTimeout(waitForSwipers, 100);
  }
}

// Start checking for swipers when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForSwipers);
} else {
  waitForSwipers();
}

// Handle resize events
let resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleBenefitBarAutoplay, 250);
});
